const apiErrorType = {
  ACCESS_FORBIDDEN: 'ACCESS_FORBIDDEN',
  PAYMENT_MULTIPLE_AIVF_BLOCK: 'PAYMENT_MULTIPLE_AIVF_BLOCK',
  PAYMENT_MULTIPLE_PIN_BLOCK: 'PAYMENT_MULTIPLE_PIN_BLOCK',
  PAYMENT_INVALID_AIVF: 'PAYMENT_INVALID_AIVF',
  PAYMENT_INVALID_PIN: 'PAYMENT_INVALID_PIN',
  PAYMENT_MULTIPLE_OTP_BLOCK: 'PAYMENT_MULTIPLE_OTP_BLOCK',
  PAYMENT_INVALID_OTP: 'PAYMENT_INVALID_OTP',
  PAYMENT_MISSING_PIN: 'PAYMENT_MISSING_PIN',
  PAYMENT_DUPLICATE_REQUEST: 'PAYMENT_DUPLICATE_REQUEST',
  PAYMENT_INSUFFICIENT_CREDIT: 'PAYMENT_INSUFFICIENT_CREDIT',
  PAYMENT_LENDER_SERVER_FAIL: 'PAYMENT_LENDER_SERVER_FAIL',
  PAYMENT_INVALID_TRANSACTION: 'PAYMENT_INVALID_TRANSACTION',
  PAYMENT_TRANSACTION_TIMEOUT: 'PAYMENT_TRANSACTION_TIMEOUT',
  PAYMENT_INVALID_AMOUNT: 'PAYMENT_INVALID_AMOUNT',
  PAYMENT_INVALID_TENURE: 'PAYMENT_INVALID_TENURE',
  PAYMENT_BLOCKED_USER: 'PAYMENT_BLOCKED_USER',
  PAYMENT_INSUFFICIENT_AMOUNT: 'PAYMENT_INSUFFICIENT_AMOUNT',
  PAYMENT_MULTIPLE_PHONE_NUMBER_BLOCK: 'PAYMENT_MULTIPLE_PHONE_NUMBER_BLOCK',
  PAYMENT_MAX_AMOUNT_LIMIT: 'PAYMENT_MAX_AMOUNT_LIMIT',
  PAYMENT_MIN_AMOUNT_LIMIT: 'PAYMENT_MIN_AMOUNT_LIMIT',
  PAYMENT_GENERIC_ERROR: 'PAYMENT_GENERIC_ERROR',
  ACTIVATION_MOBILE_NOT_PA: 'ACTIVATION_MOBILE_NOT_PA',
  ACTIVATION_INVALID_OTP: 'ACTIVATION_INVALID_OTP',
  ACTIVATION_USER_BLOCKED: 'ACTIVATION_USER_BLOCKED',
  ACTIVATION_USER_NOT_PA: 'ACTIVATION_USER_NOT_PA',
  ACTIVATION_MULTIPLE_OTP_BLOCK: 'ACTIVATION_MULTIPLE_OTP_BLOCK',
  ACTIVATION_EXHAUSTED: 'ACTIVATION_EXHAUSTED',
  ACTIVATION_USER_TEMPORARY_BLOCK: 'ACTIVATION_USER_TEMPORARY_BLOCK',
  ACTIVATION_INVALID_AIVF: 'ACTIVATION_INVALID_AIVF',
  ACTIVATION_BLOCKED_CREDIT_LINE: 'ACTIVATION_BLOCKED_CREDIT_LINE',
  ACTIVATION_MULTIPLE_AIVF_BLOCK: 'ACTIVATION_MULTIPLE_AIVF_BLOCK',
  ACTIVATION_AIVF_EXHAUSTED: 'ACTIVATION_AIVF_EXHAUSTED',
  ACTIVATION_SESSION_EXPIRED: 'ACTIVATION_SESSION_EXPIRED',
  ACTIVATION_INVALID_REQUEST_PARAMETER: 'ACTIVATION_INVALID_REQUEST_PARAMETER',
  ACTIVATION_GENERIC_ERROR: 'ACTIVATION_GENERIC_ERROR',

  PIN_CHANGE_SAME_VALUE: 'PIN_CHANGE_SAME_VALUE',
  PIN_CHANGE_INVALID_VALUE: 'PIN_CHANGE_INVALID_VALUE',

  USER_NOT_REGISTERED: 'USER_NOT_REGISTERED',
  LOGIN_BLOCKED_MAX_ATTEMPTS: 'LOGIN_BLOCKED_MAX_ATTEMPTS',
  LOGIN_INVALID_AUTH: 'LOGIN_INVALID_AUTH',
  INVALID_OTP: 'INVALID_OTP',
  NTB_INSUFFICIENT_LIMIT: 'NTB_INSUFFICIENT_LIMIT',
  NTB_REJECTED_APPLICATION: 'NTB_REJECTED_APPLICATION',
};

export default apiErrorType;



// WEBPACK FOOTER //
// ./api/apiErrorType.js